/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import map from '../static/map.png'
import { Header, HeaderParagraph, CardComponent, Platforms, Footer, Icon, MobileFooter, Input } from '../components'
import { SecondSet, CircleCenter, CircleContent, Line, ThirdSet } from '../components/StyledComponents'
import { Helmet } from 'react-helmet'

const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`
const Container = styled.section`
  padding: ${props => (props.padding ? props.padding : '60px 80px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.normal ? 'normal' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const ContainerTitle = styled.h1`
  font-size: 38px;
  line-height: 1.21;
  text-align: ${props => (props.align ? props.align : 'center')};
  color: #333333;
  padding-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const ContainerSubTitle = styled.p`
  font-size: 17px;
  font-weight: 300;
  line-height: 1.53;
  text-align: center;
  color: #999999;
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 300;
    padding: 0;
    line-height: 1.63;
  }
  @media (max-width: 520px) {
  padding: 0;
`
const SpecializationWrapper = styled.div`
  width: 100%;
  max-width: 1366px;
  padding: 0 80px;
  @media (max-width: 992px) {
    padding: 0;
  }
  @media (max-width: 768px) {
    padding-top: 30px;
    & > div {
      flex-wrap: wrap;
      & > div {
        padding: 40px 20px !important;
      }
    }
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  & > div:nth-child(1) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    & > div:nth-child(1) {
      border-right: none;
      border-left: none;
      border-top: none;
    }
    & > div:nth-child(2) {
      border-top: none;
    }
    & > div:nth-child(3) {
      border-right: none;
      border-left: none;
      border-top: none;
    }
    & > div:nth-child(4) {
      border: none;
    }
    & > div:nth-child(5) {
      border-bottom: none;
      border-top: none;
    }
    & > div:nth-child(6) {
      border: none;
    }
    @media (max-width: 768px) {
      & > div:nth-child(1) {
        border-right: none;
        border-left: none;
        border-top: none;
      }
      & > div:nth-child(2) {
        border-top: none;
        border-right: none;
      }
      & > div:nth-child(3) {
        border-right: none;
        border-left: none;
        border-top: none;
      }
      & > div:nth-child(4) {
        border: none;
        border-left: 1px solid #f0ecec;
        border-bottom: 1px solid #f0ecec;
      }
      & > div:nth-child(5) {
        border: none;
      }
      & > div:nth-child(6) {
        border: none;
        border-left: 1px solid #f0ecec;
      }
    }
    @media (max-width: 520px) {
      & > div:nth-child(1) {
        border-top: 1px solid #f0ecec;
      }
      & > div {
        border-bottom: 1px solid #f0ecec !important;
        border-right: 1px solid #f0ecec !important;
        border-left: 1px solid #f0ecec !important;
      }
    }
  }
`
const PlatformsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 80px;
`
const ContainerLeft = styled.div`
  flex-basis: calc(55% - 60px);
  padding-right: 60px;
  @media (max-width: 992px) {
    padding: 0;
    flex-basis: calc(100% - 0px);
  }
  & > p {
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.8px;
    color: #333333;
    padding-bottom: 4px;
    font-weight: 500;
  }
  & > p:nth-child(2) {
    font-size: 38px;
    font-weight: 400;
    line-height: 1.2;
    padding-bottom: 10px;
    letter-spacing: 2.4px;
    font-weight: 400;
    color: #333333;
    margin: 0;
  }
  & > p:nth-child(3) {
    // width: 448px;
    font-weight: 400;
    margin-bottom: 20px;
    color: #666666;
  }
  @media (max-width: 768px) {
    & > p {
      font-size: 14px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
    }
  }
`
const ContainerRight = styled.div`
  flex-basis: 45%;
  & > div:first-child {
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
  & > div:last-child {
    display: block;
    @media (max-width: 768px) {
      padding-top: 30px;
    }
  }
`
const BigCircle = styled.div`
  & img {
    width: 100%;
    flex-basis: 45%;
    // filter: grayscale(60%);
  }
  position: relative;
  & > div:first-child {
    justify-content: space-evenly;
  }
  & > div {
    flex-basis: 50%;
  }
  & > div:nth-child(3) {
    min-height: 200px;
    & > div:first-child {
      margin-bottom: auto;
    }
    & > div:nth-child(2) {
      margin: auto;
    }
    & > div:nth-child(5) {
      margin: auto;
    }
    & > div:last-child {
      margin-bottom: auto;
    }
  }
`
const BodyWrapper = styled.div`
  & > footer:first-child {
    @media (max-width: 992px) {
      display: none;
    }
  }
  & > footer:last-child {
    display: none;
    @media (max-width: 992px) {
      display: block;
    }
  }
`
const CollapseWrapper = styled.div`
  visibility: hidden;
  display: flex !important;
  flex-direction: column;
  @media (max-width: 768px) {
    display: block;
    visibility: visible;
  }
  & button {
    align-self: center;
  }
`
const Technologies = styled.div`
  max-width: 1366px;
  width: 100%;
  margin: 0px auto;
  display: flex;
  align-items: center;
  padding: 80px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
const Backgroundwrapper = styled.div`
  background-image: url(${map});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  max-width: 100%;
  // height: 500px;
  @media (max-width: 768px) {
    & > div:nth-child(2) {
      display: none;
    }
    display: flex;
    flex-direction: column;
    height: 100%;
    & > button {
      align-self: center;
      position: relative;
      padding: 0;
      padding-right: 14px;
      -webkit-tap-highlight-color: transparent;
      &:after {
        content: '';
        width: 8px;
        height: 8px;
        position: absolute;
        border-left: 2px solid #333333;
        border-bottom: 2px solid #333333;
        transform: ${props => (props.rotate ? 'rotate(135deg)' : 'rotate(-45deg)')};
        margin-left: 6px;
        bottom: ${props => (props.rotate ? 12 : 16)}px;
      }
    }
  }
`
const OurClient = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1366px;
  margin: auto;
  padding: 0 80px;
  @media (max-width: 992px) {
    padding: 0;
  }
  & ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 0;
    margin: 0;
    justify-content: center;
    & li {
      width: calc(100% / 4);
      text-align: center;
      list-style-type: none;
      padding: 20px 40px;
      display: flex;
      height: 140px;
      justify-content: center;

      @media (max-width: 992px) {
        width: calc(100% / 3);
      }
      @media (max-width: 520px) {
        width: calc(100% / 2);
      }
      &:hover {
        & img {
          filter: grayscale(0);
        }
      }
      & a {
        display: flex;
      }
      & img {
        width: 120px;
        object-fit: contain;
        position: relative;
        /* filter: grayscale(100%); */
      }
      @media (max-width: 768px) {
        & > img {
          height: 120px;
          object-fit: contain;
        }
      }
    }
  }
`

const MobileClientLogo = styled.li`
  @media (max-width: 768px) {
    display: ${props => (props.MobileLogo === true ? 'none!important' : 'block')};
  }
`
const ButtonMLogo = styled.button`
  width: 138px;
  margin: auto;
  height: 38px;
  background: transparent;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  line-height: 1;
  color: #333333;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  box-shadow: none;
  @media (min-width: 767px) {
    display: none;
`
const ValueContainer = styled.div`
  margin: 0 auto;
  max-width: 2560px;
  margin-top: 20px;
  padding: 0px 0px 130px;
  @media (max-width: 768px) {
    margin-top: 40px;
  }
`

const ValueWrapper = styled.div``

const FirstSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 490px;
  margin: 0 auto;
  position: relative;
  top: 40px;
  @media (max-width: 520px) {
    max-width: 285px;
    top: 20px;
  }
  & div:nth-child(2) {
    position: relative;
    top: -90px;
    @media (max-width: 520px) {
      top: -50px;
    }
  }
`
const Placeholder = styled.div`
  font-size: 36px;
  width: 102px;
  height: 102px;
  border-radius: 50%;
  color: ${props => (props.selected ? '#fff' : '#999')};
  background-color: ${props => (props.selected ? '#f0425f' : '#ffffff')};
  box-shadow: ${props =>
    props.selected ? ' 0 8px 16px 0 rgba(240, 66, 95, 0.2)' : ' 0 8px 16px 0 rgba(0, 0, 0, 0.08);'};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 520px) {
    height: 60px;
    width: 60px;
    font-size: 28px;
    & svg {
      font-size: 30px;
      height: 35px;
    }
  }
`
const CareersWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & + img {
      max-width: 100% !important;
      height: 200px !important;
      object-fit: cover !important;
    }
  }
  & > h1 {
    align-self: flex-start;
    text-align: left;
  }
  & > p {
    align-self: flex-start;
    padding: 0;
    text-align: left;
  }
  & + img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
`
const VecterCircle = styled.div`
  width: 520px;
  height: 520px;
  min-width: 520px;
  min-height: 520px;
  border-radius: 50%;
  border: 1px solid #e8e5e5;
  margin: 0 auto;
  position: relative;
  @media (max-width: 768px) {
    transform: scale(0.75);
  }
  @media (max-width: 520px) {
    transform: scale(1);
    width: 320px;
    height: 320px;
    min-width: 320px;
    min-height: 320px;
  }
  @media (max-width: 360px) {
    transform: scale(0.8);
  }
`
const FirsttoSet = styled.div`
  position: absolute;
  display: flex;
`
const CircletoImage = styled.div``

const CircleWithImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > img:nth-child(1) {
    width: 102px;
    position: relative;
  }
  & > img:nth-child(2) {
    width: 36px;
    position: absolute !important;
    padding: 0 0 10px 0 !important  ;
  }
  @media (max-width: 520px) {}
    top: -40px;
  }
`
const content = {
  V: { title: 'Hospitality', dec: 'Boost your hospitality game with attractive and easy to use designs.' },
  EEE: { title: 'Law', dec: 'Use of the best UX and visual design to showcase your practice.' },
  C: {
    title: 'Retail',
    dec: 'We create websites that resonate with the need of your buyers.'
  },
  T: {
    title: 'RealEstate',
    dec: 'Websites made to look great on any device &amp; showcase your designs.'
  },
  E: {
    title: 'Manufacturing',
    dec: 'Improve your sales and client experience with our expert services.'
  },
  R: { title: 'eCommerce', dec: 'Increase your sales and traffic with customised designs.' },
  A: {
    title: 'Jobs',
    dec: 'Help your auidence find their right spot with interactive UIs.'
  },

  P: {
    title: 'Technology',
    dec: 'We understand the need for simple &amp; technologically sound designs.'
  }
}
const FormWrapper = styled.form`
  display: flex;
  padding-top:20px;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100%;
      width: 100%;
    }
  }
`
const FromGroup = styled.div`
  width: 100%;
  margin-right: 20px;
  margin: 8px;
  input,
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    width: 100%;
  }
  input {
  }
  textarea {
    padding: 10px;
    min-height: 150px;
    :focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      outline: none;
    }
  }
`
const ContactFrom = styled.div`
  margin-top: 50px;
`
const AddressWrap = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`
const AddressContent = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  a {
    color: #000;
  }
  > span {
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    color: #555;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p span {
    font-weight: bold;
    display: block;
    font-size: 16px;
    color: #000;
  }
`
export const Button = props => {
  return (
    <ButtonComponent
      color={props.color}
      height={props.height}
      width={props.width}
      background={props.background}
      border={props.border}
      radius={props.radius}
      {...props}>
      {props.title}
    </ButtonComponent>
  )
}

class WebDevelopment extends Component {
  state = {
    collapse: false,
    MobileLogo: true,
    MobileLogoText: 'View More',
    selected: 'V'
  }
  MobileLogoButton = e => {
    this.setState({ MobileLogoText: this.state.MobileLogo ? 'Less' : 'View More' })
    this.setState({ MobileLogo: !e })
  }

  render() {
    const { selected } = this.state
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Web Development Company | Website Design Developer | 8om</title>
          <meta
            name="description"
            content="A web development company with responsive website development designs to attract the user through an interactive interface, fluid navigation and modern layouts."
          />
          <meta
            name="keywords"
            content="web design, website design, website developer, web development company, responsive website development"
          />
        </Helmet>
        <Header />
        <ContentWrapper>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Web Development'}
              paragraph={
                '8OM creates websites that allure the mind of the user through their interactive interface, fluid navigation and ultra-modern designs.'
              }
            />
          </TopWrapper>
          <ImageWrapper>
            <img src={require('../static/webdevelopment.jpg')} alt="Services" />
          </ImageWrapper>
          <Container padding={'80px 0px'}>
            <ContainerTitle>Specialisation</ContainerTitle>
            <ContainerSubTitle>
              Our team of outstanding developers &amp; designers help map out your ideas into reality through the
              following ways.
            </ContainerSubTitle>
            <SpecializationWrapper>
              <div>
                <CardComponent
                  img={require('../static/productIdeation.png')}
                  alt="Product Ideation"
                  smallHeading="Product Ideation"
                  description="Strategize ideas that can be further perfected into the best, most practical
                  and innovative idea or solution before embarking on a full development
                  adventure."
                />
                <CardComponent
                  img={require('../static/webdesign.png')}
                  alt="Web Design"
                  smallHeading="Web Design"
                  description="We combine simplicity, versatility and quality to create captivating UIs that
                  establish a uniform experience across multiple browsers and devices."
                />
                <CardComponent
                  img={require('../static/webdevelopment.png')}
                  alt="Web Development"
                  smallHeading="Web Development"
                  description="Bring design ideas to life with versatile and dynamic programming to create a
                  fully functioning website that is easy to maintain and update by the clients."
                />
                <CardComponent
                  img={require('../static/webhosting.png')}
                  alt="Web Hosting"
                  smallHeading="Web Hosting"
                  description="We believe in research driven design. Analysing target market and user base to create the best user experince for the website or application."
                />
                <CardComponent
                  img={require('../static/webmaintenance.png')}
                  alt="Web Maintenance"
                  smallHeading="Web Maintenance"
                  description="Our team of highly skilled professionals give you and your website visitors a
                  seamless experience through constant updates of useful content."
                />
                <CardComponent
                  img={require('../static/custom_solutions.svg')}
                  alt="Custom Solutions"
                  smallHeading="Custom Solutions"
                  description="Bespoke automation solutions for your business, designed keeping in mind the nature of your industry, by our skilled team with expertise from over 10+ industries."
                />
              </div>
            </SpecializationWrapper>
          </Container>
          <Container background="#fafbfc">
            <ContainerTitle>Platforms</ContainerTitle>
            <ContainerSubTitle>
              We only select the best platforms to host your websites that are not only easy to operate but will also
              help you grow through a whole new business experience.
            </ContainerSubTitle>
            <PlatformsWrapper>
              <Platforms imageUrl={require('../static/Platformsicons/wordpress.png')} title="Wordpress" />
              <Platforms imageUrl={require('../static/Platformsicons/Algolia.png')} title="Algolia" />
              <Platforms imageUrl={require('../static/Platformsicons/aws.png.png')} title="AWS" />
              <Platforms imageUrl={require('../static/Platformsicons/Digital_Ocean.png')} title="Digital Ocean" />
              <Platforms imageUrl={require('../static/Platformsicons/django.png')} title="Django" />
              <Platforms imageUrl={require('../static/Platformsicons/Drupal.png')} title="Drupal" />
              <Platforms imageUrl={require('../static/Platformsicons/GCP.png')} title="GCP" />
              <Platforms imageUrl={require('../static/Platformsicons/Joomla.png')} title="Joomla" />
              <Platforms imageUrl={require('../static/Platformsicons/Magento.png')} title="Magento" />
              <Platforms imageUrl={require('../static/Platformsicons/Opencart.png')} title="Opencart" />
              <Platforms imageUrl={require('../static/Platformsicons/osCommerce.png')} title="osCommerce" />
              <Platforms imageUrl={require('../static/Platformsicons/Prestashop.png')} title="Prestashop" />
              <Platforms imageUrl={require('../static/Platformsicons/Shopify.png')} title="Shopify" />
              <Platforms imageUrl={require('../static/Platformsicons/Woocommerce.png')} title="Woocommerce" />
            </PlatformsWrapper>
          </Container>

          <Technologies>
            <ContainerLeft>
              <p>Which We Work</p>
              <p align="left">Technologies</p>
              <p>
                Our team of expert designers and developers use only the best markup languages and multimedia packages
                available in the market to execute the task with seamless perfection.
              </p>
            </ContainerLeft>
            <ContainerRight>
              {/* <OurTeamMobileView /> */}
              <BigCircle>
                <img src={require('../static/Platformsicons/Technologies.png')} alt="Team" />
              </BigCircle>
              {/*<BigCircle>
                  <ColumnWrapper>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'first'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('first')}>
                        <CircleImage imageSize={this.state.active === 'first' && `${this.state.bigImage}px`}>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'first' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'second'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('second')}>
                        <CircleImage imageSize={this.state.active === 'second' && `${this.state.bigImage}px`}>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'second' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'third'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('third')}>
                        <CircleImage imageSize={this.state.active === 'third' && `${this.state.bigImage}px`}>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'third' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                  </ColumnWrapper>
                  <ColumnWrapper>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'fourth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('fourth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'fourth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'fourth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.medImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'fifth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('fifth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'fifth' && this.state.mobileView === true
                              ? `${this.state.medImage}px`
                              : '65px'
                          }>
                          <img src={require('../static/work2.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'fifth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'sixth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('sixth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'sixth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'sixth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                  </ColumnWrapper>
                  <ColumnWrapper>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'seventh'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('seventh')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'seventh' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'seventh' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'eight'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('eight')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'eight' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'eight' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'nine'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('nine')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'nine' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'nine' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'tenth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('tenth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'tenth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'tenth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'eleventh'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('eleventh')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'eleventh' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'eleventh' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'twelth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('twelth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'twelth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'twelth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                  </ColumnWrapper>
                  </BigCircle>*/}
            </ContainerRight>
          </Technologies>

          <ValueContainer>
            <ValueWrapper>
              <ContainerTitle>Industries</ContainerTitle>
              <ContainerSubTitle style={{ paddingBottom: 60 }}>
                Our core and comprehensive services include:
              </ContainerSubTitle>
            </ValueWrapper>
            <VecterCircle>
              <FirstSet>
                <CircleWithImage>
                  <Placeholder
                    imageUrl={require('../static/Platformsicons/wordpress.png')}
                    selected={selected === 'R'}
                    onClick={() => this.setState({ selected: 'R' })}>
                    <Icon icon="eCommerce" color={selected === 'R' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircleWithImage>
                <CircleWithImage>
                  <Placeholder selected={selected === 'V'} onClick={() => this.setState({ selected: 'V' })}>
                    <Icon icon="hospitality" color={selected === 'V' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircleWithImage>
                <CircletoImage>
                  <Placeholder selected={selected === 'A'} onClick={() => this.setState({ selected: 'A' })}>
                    <Icon icon="jobs" color={selected === 'A' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircletoImage>
              </FirstSet>
              <SecondSet>
                {/* Center Circle */}
                <CircleCenter>
                  <CircleContent>
                    <img src={require('../static/brand.svg')} alt="8OM" />
                    <h3>{content[this.state.selected].title}</h3>
                    <Line />
                    <p>{content[this.state.selected].dec}</p>
                  </CircleContent>
                </CircleCenter>
                {/* Center Circle */}

                <CircleWithImage>
                  <Placeholder selected={selected === 'EEE'} onClick={() => this.setState({ selected: 'EEE' })}>
                    <Icon icon="law" color={selected === 'EEE' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircleWithImage>
                <CircleWithImage>
                  <Placeholder selected={selected === 'E'} onClick={() => this.setState({ selected: 'E' })}>
                    <Icon icon="manufacturing" color={selected === 'E' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircleWithImage>
              </SecondSet>

              <ThirdSet>
                <CircleWithImage>
                  <Placeholder selected={selected === 'T'} onClick={() => this.setState({ selected: 'T' })}>
                    <Icon icon="realestate" color={selected === 'T' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircleWithImage>
                <CircleWithImage>
                  <Placeholder selected={selected === 'C'} onClick={() => this.setState({ selected: 'C' })}>
                    <Icon icon="retail" color={selected === 'C' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircleWithImage>
                <CircletoImage>
                  <Placeholder selected={selected === 'P'} onClick={() => this.setState({ selected: 'P' })}>
                    <Icon icon="technology" color={selected === 'P' ? '#FFF' : '#000'} />
                  </Placeholder>
                </CircletoImage>
              </ThirdSet>
            </VecterCircle>
          </ValueContainer>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Get In Touch'}
              paragraph={'Sent us a message'}
            />

            <FlexContainer>
              <ContactFrom>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FlexContainer>
                    <FromGroup>
                      <Input type="name" icon="user" name="Name" placeholder="Name" changeColor={'#35cc62'} required />
                    </FromGroup>
                    <FromGroup>
                      <Input
                        type="email"
                        name="_replyto"
                        icon="email"
                        placeholder="Email"
                        changeColor={'#35cc62'}
                        onChange={this.handleChange}
                        value={this.state.email}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <Input
                        type="phone"
                        name="contact"
                        icon="contact"
                        placeholder="Phone"
                        changeColor={'#35cc62'}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <textarea name="textarea" id="" placeholder="Your message type here" />
                    </FromGroup>
                  </FlexContainer>
                  <input type="hidden" name="_next" value="/" />
                  <FromGroup>
                    <Button type="submit" title="Submit" />
                  </FromGroup>
                </form>
              </ContactFrom>

              <AddressWrap>
                <AddressContent>
                  <span>
                    <Icon icon="contact" />
                  </span>
                  <p>
                    Phone
                    <span>
                      <a href="tel:+918076157787"> +91 8076157787</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="email" />
                  </span>
                  <p>
                    Email
                    <span>
                      <a href="mailto:harsh@8om.io"> harsh@8om.io</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="website" />
                  </span>
                  <p>
                    Website
                    <span>8om.io</span>
                  </p>
                </AddressContent>
                {/* <AddressContent>
                  <span>
                    <Icon icon="location" />
                  </span>
                  <p>
                    Location
                    <span>
                      3rd Floor, Plot No. 8 Balaji Estate,
                      <br /> Guru Ravidas Marg, Kalkaji,
                      <br /> New Delhi, Delhi 110019
                    </span>
                  </p>
               </AddressContent> */}
              </AddressWrap>
            </FlexContainer>
          </TopWrapper>
          <Container normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
            <ContainerTitle>Our Clients Around The World</ContainerTitle>
            <ContainerSubTitle>
              Our clients are valuable to us and we’re always inspired by them and their need to make their business
              better.
            </ContainerSubTitle>

            <Backgroundwrapper>
              <OurClient>
                <ul>
                  <li>
                    <img src={require('../static/client_logo/bonobology.jpg')} alt="Bonobology" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/tanoshiitrail.png')} alt="Tanoshii Trail" />
                  </li>

                  <li>
                    <img src={require('../static/client_logo/beccos.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/scale_labs.jpg')} alt="Scalelabs" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/teafloor.png')} alt="Teafloor" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/vikas_spools.jpg')} alt="Vikas Spools" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/truly_madly.jpg')} alt="Truly Madly" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/greenchoice.png')} alt="Green Choice" />
                  </li>
                </ul>
              </OurClient>
            </Backgroundwrapper>
          </Container>
        </ContentWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}

export default withRouter(WebDevelopment)



// WEBPACK FOOTER //
// ./src/pages/WebDevelopment.js